module.exports = __webpack_public_path__ + "static/media/kelava.cae377b0.png";